import { render, staticRenderFns } from "./ManagerIntegrationFormTab.vue?vue&type=template&id=3158ff9d&scoped=true&"
import script from "./ManagerIntegrationFormTab.vue?vue&type=script&lang=js&"
export * from "./ManagerIntegrationFormTab.vue?vue&type=script&lang=js&"
import style0 from "./ManagerIntegrationFormTab.vue?vue&type=style&index=0&id=3158ff9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158ff9d",
  null
  
)

export default component.exports